import { makeStyles } from "@material-ui/core";
import styled from "styled-components";
import { theme as themeConfig } from "@themes";

export const SearchField = styled.div`
width: 20%;
height: 40.8px;
background: ${({ theme }) => theme.neutral.white};
display: flex;
align-items: center;
border-bottom: 1px solid ${({ theme }) => theme.neutral.gray[600]};
margin-top: 0.8rem;
margin-right: 1rem;
svg {
  position: absolute;
}
input {
  font-size: 13px;
  font-weight: 400;
  border: none;
  outline: none;
  width: 85%;
  box-shadow: none;
  margin-left: 2rem;
}
input:focus {
  box-shadow: none;
  outline: none;
  border: none;
}
input::placeholder {
  color: ${({ theme }) => theme.neutral.gray[1300]};
}
`;
export const SurveysHomeImgDefault = styled.div`
  img {
    margin-top: 0 !important;
    max-height: 145px;
    object-fit: cover;
    object-position: top;
    width: 100% !important;
  }
`;

export const useStyles = makeStyles(() => ({
  active: {
    "& svg": {
      color: themeConfig.tabs.selected,
    },
    "&:disabled svg": {
      color: themeConfig.neutral.gray[500],
    },
  },
  titleOfList: {
    margin: "0.8em 0.45em",
    fontSize: "1.25rem",
    fontWeight: "500",
    lineHeight: "1.6",
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  },
  rowContainList: {
    width: "100%",
    margin: "0",
    "@media only screen and (max-width: 768px)": {
      justifyContent: "center",
    },
  },
  colCardList: (props) => ({
    width: "100%",
    maxWidth: props.identity === "survey-homelist" ? "33.333%" : "230px",
    margin:
      props.identity === "survey-list" ||
        props.identity === "survey-list-manage"
        ? "2em 0em"
        : "1em 0em",
  }),
}));
